<template>
  <ngc-modal
    :open="showModal"
    variant="decide"
    :title.prop="'Still working?'"
    @close="extendSession"
  >
    <div>{{ bodyText }}</div>
    <div class="mt-6">
      <strong>{{ timeRemainingText }}</strong> minutes left
    </div>

    <!-- ngc-modal's decide footer hardcodes "Cancel"; filling the slot lets us label both buttons. -->
    <div
      slot="footer"
      class="session-timeout-actions"
    >
      <ngc-button
        variant="secondary"
        @click="extendSession"
      >
        Continue Working
      </ngc-button>
      <ngc-button
        variant="primary"
        @click="logout"
      >
        Sign Out
      </ngc-button>
    </div>
  </ngc-modal>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'EvaultSessionTimeoutModal',
  props: {
    display: {
      type: Boolean,
      required: true,
      default: false
    },
    totalSeconds: {
      type: Number,
      required: false,
      default: 5 * 60
    }
  },

  data () {
    return {
      showModal: null,
      secondsRemaining: null,
      timerInterval: null,
      bodyText: 'nCino eVault automatically signs out after being idle for 15 minutes. This helps ensure your information remains secure.'
    }
  },

  computed: {
    timeRemainingText () {
      const secs = this.secondsRemaining % 60
      const minutes = Math.floor(this.secondsRemaining / 60)
      return minutes + ':' + `${secs < 10 ? '0' + secs : secs}`
    }
  },

  watch: {
    display (newVal) {
      this.showModal = newVal
      if (newVal) {
        this.secondsRemaining = this.totalSeconds
        this.timerInterval = setInterval(() => {
          if (this.display && this.secondsRemaining > 0) {
            this.secondsRemaining -= 1
          } else if (this.display) {
            this.logout()
          }
        }, 1000)
      } else {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }
    },
    totalSeconds (newVal) {
      if (newVal) {
        this.secondsRemaining = newVal
      } else {
        this.secondsRemaining = 5 * 60
      }
    }
  },

  created () {
    this.showModal = this.display
  },

  methods: {
    ...mapMutations(['resetAppTimeout']),
    extendSession () {
      this.resetAppTimeout()
      this.$emit('extend')
    },
    logout () {
      sessionStorage.clear()
      window.location.assign('/logout')
    }
  }
}
</script>

<style lang="scss" scoped>

/* Mirrors Gator's .gator-modal-action-buttons so the slotted footer keeps stock spacing. */
.session-timeout-actions {
  display: flex;
  gap: var(--spacing-5);
  margin-left: auto;
}

@media (max-width: 600px) {
  .session-timeout-actions {
    flex-direction: column-reverse;
    width: 100%;
    margin-left: 0;
  }

  .session-timeout-actions ngc-button {
    --ngc-button-width: 100%;
  }
}

</style>
